import * as React from 'react';
import { connect } from 'react-redux';

// Components
import { DefaultWrapper } from '../../../components/Layout/DefaultWrapper';
import MenuOpener from '../../../components/MenuOpener';
import Footer from '../../../components/Layout/Footer';

// Screens
import Feature from './screens/Feature';
import HowWeDidItScreen from './screens/HowWeDidIt';
import UnmetNeedsScreen from './screens/UnmetNeeds';
import FinalProjectScreen from './screens/FinalProject';
import CounterScreen from './screens/Counter';
import FooterScreen from './screens/Footer';

const AdvocatingForPatientsHope = () => (
  <DefaultWrapper>
    {/* menu */}
    <MenuOpener className="menu-opener" />
    {/* Screens */}
    <Feature />
    <HowWeDidItScreen />
    <UnmetNeedsScreen />
    <FinalProjectScreen />
    <CounterScreen />
    <FooterScreen />
    <Footer />
  </DefaultWrapper>
);

export default connect()(AdvocatingForPatientsHope);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/AdvocatingForPatientsHope/index.jsx